import { CasesListView } from './Components/CasesListView';

export default function CasePage() {
  return <CasesListView />;
}